<template>
  <div
    v-if="
      has_perm('create_customer') ||
        GET_ACCOUNT_DATA.id == 1 ||
        has_perm('update_customer')
    "
  >
    <div>
      <!-- v-show="(this.$route.params.id == '0' ? true : false)" -->
      <!-- <lte-button  type="btn
                        btn-primary" v-bind:class="(add_personal == true ? 'active': '')" right_icon="fa
                        fa-plus" @click="callbackAddPersonal($event)">{{$t('customer.personal')}}</lte-button> -->
      <!-- v-show="(this.$route.params.id == '0' ? true : false)"                         -->
      <!-- <lte-button type="btn
                        btn-primary" v-bind:class="(add_company == true ? 'active': '')" right_icon="fa
                        fa-plus" @click="callbackAddCompany($event)">{{$t('customer.company')}}</lte-button> -->
    </div>

    <br />

    <customer-add-personal
      v-if="add_personal === true"
      :customer_id="customer_id"
      :callback="callback"
      :resident_type="'tenant'"
    />
    <customer-add-company
      v-if="add_company === true"
      :customer_id="customer_id"
      :callback="callback"
      :resident_type="'tenant'"
    />
  </div>
</template>

<script>
import CustomerAddPersonal from "./CustomerAddPersonalV2";
import CustomerAddCompany from "./CustomerAddCompany";
import utils from '@/lib/utils';
import { mapGetters, mapActions } from "vuex";
//import LTEButton from "@/components/LTEButton.vue";

export default {
  name: "CustomerAdd",
  data() {
    return {
      privilege: {
        customer: [
          {
            id: 4,
            text: "Thông Thường"
          },
          {
            id: 5,
            text: "Khách"
          },
          {
            id: 10,
            text: "Doanh Nghiệp"
          }
        ]
      },

      customer_id: 0,
      add_personal: true,
      add_company: false,

      callback: null,

      ischeck: false,
      assignShow: false,
      actionType: "",
      timeCurrent: "2019-01-16T06:00:00Z",

      modal_title: ""
    };
  },

  watch: {},

  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "CUSTOMER_DETAIL_DATA",
      "UPDATE_CUSTOMER_DATA",
      "GET_ACCOUNT_DATA"
    ]),
    privilegeOptions: function() {
      return this.privilege.customer;
    }
  },

  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_MEMBERROLECODES"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    callbackAddPersonal: function() {
      this.add_personal = true;
      this.add_company = false;
    },

    callbackAddCompany: function() {
      this.add_personal = false;
      this.add_company = true;
    }
  },
  mounted() {
    let filter = {
      params: {
        isCustomer: true
      }
    };
    this.GET_MEMBERROLECODES(filter);
    if (this.$route.query.is_company === true || this.$route.query.is_company === "true") {
      this.add_company = true;
      this.add_personal = false;
    } else {
      this.add_company = false;
      this.add_personal = true;
    }

    // set method callback
    this.callback = this.$route.query.callback;
  },
  components: {
    //"lte-button": LTEButton,
    "customer-add-personal": CustomerAddPersonal,
    "customer-add-company": CustomerAddCompany
  }
};
</script>

<style lang="" scoped>
@media (min-width: 768px) {
  .modal-dialog {
    width: 800px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Customer/CustomerAdd.vue